
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bcks/invitation/precollection",
      function () {
        return require("private-next-pages/bcks/invitation/precollection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bcks/invitation/precollection"])
      });
    }
  